import { useState } from "react";

import { X } from "lucide-react";

import { useSetMentorship, MentorshipStatus } from "@/entities/mentorship";
import { Button } from "@/shared/ui/button";
import { Input } from "@/shared/ui/input";
import { Label } from "@/shared/ui/label";
import { Modal } from "@/shared/ui/Modal";

interface ConfirmRemoveModal {
  id: string;
  username: string;
}

export const ConfirmRemoveModal = ({ id, username }: ConfirmRemoveModal) => {
  const [usernameInput, setUsernameInput] = useState("");
  const { mutateAsync } = useSetMentorship();

  const handleConfirm = async () => {
    mutateAsync({ id, status: MentorshipStatus.INACTIVE });
  };

  return (
    <Modal>
      <Modal.Trigger size={"icon"}>
        <X />
      </Modal.Trigger>
      <Modal.Content>
        <Modal.Title>Подтвердите действие</Modal.Title>
        <Label>Введите никнейм ученика {username}</Label>
        <Input
          placeholder={username}
          onChange={(e) => setUsernameInput(e.target.value)}
          value={usernameInput}
        />
        <Button onClick={handleConfirm} disabled={usernameInput !== username}>
          Сохранить
        </Button>

        <Modal.Close />
      </Modal.Content>
    </Modal>
  );
};
